import type { PendingDecision } from "@scheduler/shared";

/**
 * The Approvals queue in two sections instead of a filter (punch list S32, Jeremy's option B,
 * 3 Nov 2026): what comes to you as somebody's supervisor first, then what you see only because
 * you are HR, so the first can be read without the second. The capacity is the API's
 * (`decideAs`); this only groups by it. "You're the PM" is kept for completeness: field work has
 * had no approval step since 27 Oct 2026, so the API never lists one.
 */
export const SECTION_TITLE: Record<PendingDecision["decideAs"], string> = {
  SUPERVISOR: "As your supervisor",
  HR: "As HR",
  PM: "You're the PM",
};

/** The order the sections appear in. */
const ORDER: readonly PendingDecision["decideAs"][] = ["SUPERVISOR", "HR", "PM"];

export interface PendingSection {
  readonly decideAs: PendingDecision["decideAs"];
  readonly title: string;
  readonly items: readonly PendingDecision[];
}

/** Only the sections with something in them, in ORDER; each keeps the queue's own order (oldest first). */
export function sectionsFor(items: readonly PendingDecision[]): PendingSection[] {
  return ORDER.flatMap((decideAs) => {
    const mine = items.filter((item) => item.decideAs === decideAs);
    return mine.length ? [{ decideAs, title: SECTION_TITLE[decideAs], items: mine }] : [];
  });
}
